<template>
  <v-dialog scrollable fullscreen v-model="config.status.active">
    <v-card class="dialog client apply publish">
      <v-card-title class="grey lighten-3 pa-0">
        <v-form ref="form" v-model="form.valid" lazy-validation style="width:100%;">
          <v-row dense v-if="$vuetify.breakpoint.mdAndUp" class="pa-0">
            <v-col cols="4" class="secondary white--text px-4 py-3">
              <span class="headline">{{ isPublished ? '申込書の再発行' : '申込書の発行' }}</span>
            </v-col>
            <v-col cols="8"></v-col>
            <v-col cols="4" class="secondary">
              <v-tabs fixed-tabs centered icons-and-text
                v-model="config.about.page"
                background-color="secondary">
                <v-tabs-slider></v-tabs-slider>
                <v-tab v-for="item in authedNavigation" :key="item.path" class="mx-auto">
                  {{ item.meta.label }}
                  <v-icon small>{{ `${(item.path === printAboutPage ? 'fas' : 'fal')} ${item.meta.icon[1]}` }}</v-icon>
                </v-tab>
              </v-tabs>
            </v-col>
            <v-col cols="2" class="px-2">
              <v-menu lazy offset-y full-width
                v-model="config.datepickers.start"
                transition="scale-transition"
                min-width="290px"
                :close-on-content-click="false"
                :nudge-right="40">
                <template v-slot:activator="{ on }">
                  <v-text-field readonly
                    v-model="printFormStart"
                    v-on="on"
                    label="出発日"
                  />
                </template>
                <v-date-picker
                  v-model="form.program.start"
                  locale="ja"
                  color="amber"
                  :day-format="date => new Date(date).getUTCDate()"
                  @input="config.datepickers.start = false"
                />
              </v-menu>
            </v-col>
            <v-col cols="2" class="px-2">
              <v-menu lazy offset-y full-width
                v-model="config.datepickers.end"
                transition="scale-transition"
                min-width="290px"
                :close-on-content-click="false"
                :nudge-right="40">
                <template v-slot:activator="{ on }">
                  <v-text-field readonly
                    v-model="printFormEnd"
                    v-on="on"
                    label="帰国日"
                  />
                </template>
                <v-date-picker
                  v-model="form.program.end"
                  locale="ja"
                  color="amber"
                  :day-format="date => new Date(date).getUTCDate()"
                  @input="config.datepickers.end = false"
                />
              </v-menu>
            </v-col>
            <v-col cols="2" class="px-2">
              <v-select required v-model="form.office"
                label="発行オフィス"
                :items="getBelongItems"
                item-text="text"
                item-value="value"
                :rules="rules.office"
                @change="preview"
              />
            </v-col>
            <v-col cols="2" class="px-2">
              <v-select requried v-model="form.arranger"
                label="手配担当者"
                :items="getArrangerItems"
                item-text="name"
                item-value="userid"
                :rules="rules.arranger"
              />
            </v-col>
          </v-row>
          <v-row dense v-else-if="printPublisherPage === 'about'" class="pa-0">
            <v-col cols="12">
              <v-tabs fixed-tabs icons-and-text
                v-model="config.about.page"
                background-color="secondary">
                <v-tabs-slider></v-tabs-slider>
                <v-tab v-for="item in authedNavigation" :key="item.path" class="mx-auto">
                  {{ item.meta.label }}
                  <v-icon small>{{ `${(item.path === printAboutPage ? 'fas' : 'fal')} ${item.meta.icon[1]}` }}</v-icon>
                </v-tab>
              </v-tabs>
            </v-col>
          </v-row>
          <v-row dense v-else-if="printPublisherPage === 'pdfmaker'" justify-center class="pa-0">
            <v-col cols="6" class="px-2">
              <v-menu lazy offset-y full-width
                v-model="config.datepickers.start"
                transition="scale-transition"
                min-width="290px"
                :close-on-content-click="false"
                :nudge-right="40">
                <template v-slot:activator="{ on }">
                  <v-text-field readonly
                    v-model="printFormStart"
                    v-on="on"
                    label="出発日"
                  />
                </template>
                <v-date-picker
                  v-model="form.program.start"
                  locale="ja"
                  color="amber"
                  :day-format="date => new Date(date).getUTCDate()"
                  @input="config.datepickers.start = false"
                />
              </v-menu>
            </v-col>
            <v-col cols="6" class="px-2">
              <v-menu lazy offset-y full-width
                v-model="config.datepickers.end"
                transition="scale-transition"
                min-width="290px"
                :close-on-content-click="false"
                :nudge-right="40">
                <template v-slot:activator="{ on }">
                  <v-text-field readonly
                    v-model="printFormEnd"
                    v-on="on"
                    label="帰国日"
                  />
                </template>
                <v-date-picker
                  v-model="form.program.end"
                  locale="ja"
                  color="amber"
                  :day-format="date => new Date(date).getUTCDate()"
                  @input="config.datepickers.end = false"
                />
              </v-menu>
            </v-col>
            <v-col cols="6" class="px-2">
              <v-select required v-model="form.office"
                label="発行オフィス"
                :items="getBelongItems"
                item-text="text"
                item-value="value"
                :rules="rules.office"></v-select>
            </v-col>
            <v-col cols="6" class="px-2">
              <v-select requried v-model="form.arranger"
                label="手配担当者"
                :items="getArrangerItems"
                item-text="name"
                item-value="userid"
                :rules="rules.arranger"></v-select>
            </v-col>
          </v-row>
        </v-form>
      </v-card-title>
      <v-card-text v-if="$vuetify.breakpoint.mdAndUp" class="pa-0">
        <v-container fluid pa-0 fill-height>
          <v-row dense>
            <v-col cols="4" class="pane about">
              <ClientAboutBasic embedded
                v-if="printAboutPage === 'basic'"
                ref="basic"
                @update="get({ type: 'basic' })"
                @emit="emitted"
              />
              <ClientAboutGuardians embedded
                v-else-if="printAboutPage === 'guardians'"
                ref="guardians"
                @update="get({ type: 'guardians' })"
                @emit="emitted"
              />
            </v-col>
            <v-col cols="8"
              v-if="config.status.active"
              class="pane pdfmaker">
              <PDFMakerPane
                ref="viewer"
                :form="form"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-text v-else style="position:relative;box-sizing:border-box;">
        <v-window v-model="config.publisher.page" class="panes">
          <v-window-item :value="0" class="pane">
            <v-container pa-0 fill-height>
              <v-row row>
                <ClientAboutBasic
                  v-show="printAboutPage === 'basic'"
                  ref="basic"
                  @emit="emitted"
                />
                <ClientAboutGuardians
                  v-show="printAboutPage === 'guardians'"
                  ref="guardians"
                  @emit="emitted"
                />
              </v-row>
            </v-container>
          </v-window-item>
          <v-window-item :value="1" class="pane">
            <v-container pa-0 fill-height>
              <v-row row v-if="config.status.active">
                <PDFMakerPane
                  ref="viewer"
                  :form="form"
                  :status="config.status"
                />
              </v-row>
            </v-container>
          </v-window-item>
        </v-window>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions v-if="$vuetify.breakpoint.mdAndUp" class="pa-0">
        <v-row dense>
          <v-col cols="4" class="text-right pa-2 grey lighten-4">
            <v-btn v-if="!isEditing" depressed
              color="secondary"
              :loading="isLoading"
              @click="edit({ type: 'open' })">
              <v-icon small>fal fa-pencil</v-icon>&nbsp;編集する
            </v-btn>
            <v-btn v-if="isEditing" depressed
              color="secondary"
              :loading="isLoading"
              :disabled="($refs.basic == null || !$refs.basic.isValid) && ($refs.guardians == null || !$refs.guardians.isValid)"
              @click="edit({ type: 'save' })">
              <v-icon small>fal fa-check</v-icon>&nbsp;保存する
            </v-btn>
            <v-btn v-if="isEditing" depressed
              color="secondary"
              @click="edit({ type: 'close' })">
              <v-icon small>fal fa-times</v-icon>&nbsp;編集を止める
            </v-btn>
          </v-col>
          <v-col cols="2" class="text-center pa-2">
            <v-btn text
              color="secondary"
              :loading="isLoading"
              @click="preview">プレビューを更新する</v-btn>
          </v-col>
          <v-col cols="6" class="text-right pa-2">
            <v-btn text color="secondary" @click="close">閉じる</v-btn>
            <v-btn depressed
              v-if="isPublished"
              color="secondary"
              :loading="isLoading"
              :disabled="!isValid"
              @click.stop="republish">再発行する</v-btn>
            <v-btn depressed
              v-else
              color="secondary"
              :loading="isLoading"
              :disabled="!isValid"
              @click.stop="publish">発行する</v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
      <v-card-actions v-else-if="printPublisherPage === 'about'">
        <v-row row v-if="!isEditing">
          <v-col class="text-center">
            <v-btn text color="secondary" @click="close">閉じる</v-btn>
          </v-col>
          <v-col class="text-center">
            <v-btn depressed
              color="secondary"
              :loading="isLoading"
              @click="edit({ type: 'open' })">編集する</v-btn>
          </v-col>
          <v-col class="text-center">
            <v-btn text color="secondary" @click="page({dest: 1})">次へ</v-btn>
          </v-col>
        </v-row>
        <v-row row v-else>
          <v-col class="text-center">
            <v-btn text
              color="secondary"
              @click="edit({ type: 'close' })"><v-icon small>fal fa-times</v-icon>&nbsp;編集を止める</v-btn>
          </v-col>
          <v-col class="text-center">
            <v-btn depressed
              color="secondary"
              :loading="isLoading"
              :disabled="$refs.about == null || !$refs.about.isValid"
              @click="edit({ type: 'save' })"><v-icon small>fal fa-check</v-icon>&nbsp;保存する</v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
      <v-card-actions v-else-if="printPublisherPage === 'pdfmaker'">
        <v-btn text color="secondary" @click="page({dest: 0})">前へ</v-btn>
        <v-spacer></v-spacer>
        <v-btn text color="secondary" @click="close">閉じる</v-btn>
        <v-btn depressed color="secondary"
          :loading="isLoading"
          :disabled="!isValid" @click.stop="isPublished ? republish() : publish()">発行する</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ClientAboutRoutes from '@/router/client/about'
import ClientAboutBasic from '@/pages/client/pages/about/pages/basic'
import ClientAboutGuardians from '@/pages/client/pages/about/pages/guardians'
import PDFMakerPane from './panes/pdfmaker'
import _ from 'lodash'
const DEF = {
  PAGE: 'main',
  ABOUT: {
    PAGE: 0
  },
  PUBLISHER: {
    PAGE: 0
  }
}
export default {
  name: 'publishModal',
  components: {
    ClientAboutBasic,
    ClientAboutGuardians,
    PDFMakerPane
  },
  props: [
    'item'
  ],
  data () {
    return {
      socket: null,
      config: {
        status: {
          active: false,
          loading: true,
          editing: false
        },
        datepickers: {
          start: false,
          end: false
        },
        valid: {
          urls: ['basic', 'guardians']
        },
        publisher: {
          page: DEF.PUBLISHER.PAGE,
          pages: ['about', 'pdfmaker']
        },
        about: {
          page: DEF.ABOUT.PAGE,
          pages: ['basic', 'guardians']
        },
        page: DEF.PAGE
      },
      meta: {
        about: {
          pages: {
            basic: '基本情報',
            gurdians: '保護者情報'
          }
        },
        authors: []
      },
      form: {
        valid: true,
        office: '',
        arranger: '',
        program: {
          start: '',
          end: ''
        },
        basic: {},
        guardians: []
      },
      rules: {
        office: [
          v => !!v || '必須項目です'
        ],
        arranger: [
          v => !!v || '必須項目です'
        ]
      }
    }
  },
  mounted () {
    this.$set(this, 'socket', this.$store.getters['config/get']('socket'))
  },
  methods: {
    emitted: function (req) {
      if (
        req &&
        req.action &&
        typeof this[req.action] === 'function'
      ) {
        this[req.action](req.data)
      }
    },
    get: function (req) {
      const { type, callback } = req || {}
      const cid = this.$route.params.id
      this.$firebase.auth().currentUser.getIdToken(true).then(token => {
        this.axios.post(`${this.$url.api}about/get/${type || 'application '}`, { cid }, {
          headers: {
            'firebase-token': token
          }
        }).then(res => {
          console.log(res)
          if (res.data && res.data.success) {
            if (type && type !== 'application') {
              this.$set(this.form, type, res.data.data)
            } else {
              this.$set(this.form, Object.assign(this.form, res.data.data))
            }
            if (typeof callback === 'function') {
              this.$nextTick(() => {
                callback(res.data.data)
              })
            }
            this.$set(this.config.status, 'loading', false)
          }
        })
      })
    },
    page: function (req) {
      if (req && req.dest != null) {
        this.$set(this.config.publisher, 'page', req.dest)
        if (req.dest === 1) {
          this.get()
        }
      }
    },
    validate: function (status) {
      if (status == null) {
        this.$refs.form.validate()
      } else {
        this.$set(this.form, 'valid', status)
      }
    },
    edit: function (req) {
      const { type } = req
      const page = this.config.about.pages[this.config.about.page] || ''
      if (type && this.$refs[page]) {
        if (type === 'open') {
          this.$refs[page].prepare()
          this.$set(this.config.status, 'editing', true)
        } else if (type === 'close') {
          this.$refs[page].close()
          this.$set(this.config.status, 'editing', false)
        } else if (type === 'save') {
          this.$refs[page].submit()
          this.$set(this.config.status, 'editing', false)
        }
      }
    },
    state: function (req) {
      const { type, status } = req
      this.$set(this.config.status, type, status)
    },
    publish: function () {
      if (this.$refs.form.validate()) {
        this.submit({
          type: 'publish',
          id: this.$props.item.id,
          title: this.$props.item.title,
          arrangeType: this.$props.item.type,
          arranger: this.form.arranger,
          doc: this.$refs.viewer.getDocData(),
          start: this.form.program.start,
          end: this.form.program.end
        })
      }
    },
    republish: function () {
      if (this.$refs.form.validate()) {
        this.submit({
          type: 'republish',
          id: this.$props.item.id,
          mid: this.form.mid,
          title: this.$props.item.title,
          arrangeType: this.$props.item.type,
          arranger: this.form.arranger,
          doc: this.$refs.viewer.getDocData(),
          start: this.form.program.start,
          end: this.form.program.end
        })
      }
    },
    preview: function () {
      if (this.$refs.viewer) {
        this.$nextTick(() => {
          this.$refs.viewer.update()
        })
      }
    },
    preSubmit: function (req) {
      const { type, id, mid, title, arrangeType, arranger, doc, start, end } = req
      const cid = this.$route.params.id
      const urls = {
        publish: `${this.$url.api}apply/doc/publish/${id}`,
        republish: `${this.$url.api}apply/doc/republish/${id}`
      }
      const fds = {
        publish: { cid, title, type: arrangeType, arranger, doc, start, end },
        republish: { cid, mid, title, arranger, doc, start, end }
      }
      if (type && urls[type] && fds[type]) {
        const url = urls[type]
        const fd = fds[type]
        this.$set(this.config.status, 'loading', true)
        return { url, fd, type }
      } else {
        return false
      }
    },
    submit: function (req) {
      const dt = this.preSubmit(req)
      if (dt) {
        const { url, fd, type } = dt
        this.$firebase.auth().currentUser.getIdToken(true).then(token => {
          this.axios.post(url, fd, {
            headers: {
              'firebase-token': token
            },
            onUploadProgress: (e) => {
              this.$set(this.config.status, 'loading', Math.ceil((e.loaded / e.total + 1) / 2 * 100))
            }
          }).then(res => {
            console.log(res)
            if (res.data && res.data.success) {
              this.postSubmit({
                type,
                item: res.data.data
              })
            } else {
              this.failSubmit(res.data.data)
            }
          }).catch(err => {
            console.log(err)
            this.failSubmit(err)
          })
        })
      }
    },
    postSubmit: function (req) {
      const { item } = req || { type: '', item: {} }
      this.$emit('done', item)
      this.emitSocket(req)
      this.close()
      this.$set(this.config.status, 'loading', false)
    },
    failSubmit: function (req) {
      this.$set(this.config.status, 'loading', false)
      const { statusCode } = req
      if (statusCode === 409) {
        this.$store.dispatch('notifier/addAlert', {
          title: '発行失敗',
          message: '手配名と同名のフォルダがライブラリに存在します。'
        })
      }
    },
    emitSocket: function (req) {
      const { type } = req
      this.socket.emit('POST_ARRANGE', Object.assign(req, {
        type: type === 'publish' ? 'insert' : 'update',
        user: this.$store.getters['author/get']('userid')
      }))
    },
    ssubmit: function () {
      if (this.$refs.form.validate() && this.$props.item && this.$props.item.id) {
        this.$set(this.config.status, 'loading', 0)
        this.$firebase.auth().currentUser.getIdToken(true).then(token => {
          if (this.form.mid) {
            this.republishArrangeDocument(token, this.form.mid).then(resPublish => {
              if (resPublish.data && resPublish.data.success) {
                this.$emit('done', resPublish.data.data)
                this.close()
              }
              this.$set(this.config.status, 'loading', false)
            })
          } else {
            this.initArrangeDirectory(token).then(resMkdir => {
              if (resMkdir && resMkdir.data && resMkdir.data.success) {
                this.publishArrangeDocument(token, resMkdir.data.data).then(resPublish => {
                  if (resPublish.data && resPublish.data.success) {
                    this.$emit('done', resPublish.data.data)

                    this.close()
                  }
                  this.$set(this.config.status, 'loading', false)
                })
              }
            }).catch(err => {
              console.log(err)
              this.$set(this.config.status, 'loading', false)
            })
          }
        })
      }
    },
    open: function () {
      const { aid, media, title, country, city, courses, stays, arrangements, start, end } = this.$props.item
      this.$set(this, 'form', {
        valid: true,
        office: this.$store.getters['author/get']('belong'),
        arranger: aid,
        mid: media,
        program: {
          title,
          country,
          city,
          courses: courses || [],
          stays: stays || [],
          arrangements: arrangements || {},
          start,
          end
        },
        basic: {},
        guardians: []
      })
      this.get({ callback: this.preview })
      this.$set(this.config, 'page', DEF.PAGE)
      this.$set(this.config.status, 'active', true)
    },
    close: function () {
      this.$set(this.config.status, 'active', false)
    },
    initArrangeDirectory: function (token) {
      return new Promise((resolve, reject) => {
        this.axios.post(`${this.$url.api}box/init/arrange/${this.$route.params.id}`, {
          id: this.$props.item.id,
          title: this.$props.item.title,
          type: this.$props.item.type,
          arranger: this.form.arranger
        }, {
          headers: {
            'firebase-token': token
          },
          onUploadProgress: (e) => {
            this.$set(this.config.status, 'loading', Math.ceil((e.loaded / e.total) / 2 * 100))
          }
        }).then(res => {
          console.log(res)
          if (res.data && res.data.success) {
            resolve(res)
          } else {
            reject(res)
          }
        }).catch(err => {
          reject(err)
        })
      })
    },
    publishArrangeDocument: function (token, mid) {
      return new Promise((resolve, reject) => {
        let data = this.$refs.viewer.getDocData()
        let name = [
          '申込書',
          this.$props.item.title
        ].join('_') + '.pdf'
        this.axios.post(this.$url.api + 'apply/doc/publish', {
          data: data,
          mid: mid,
          name: name,
          form: {
            id: this.$props.item.id,
            arranger: this.form.arranger,
            start: this.form.program.start,
            end: this.form.program.end
          }
        }, {
          headers: {
            'firebase-token': token
          },
          onUploadProgress: (e) => {
            this.$set(this.config.status, 'loading', Math.ceil((e.loaded / e.total + 1) / 2 * 100))
          }
        }).then(res => {
          console.log(res)
          if (res.data.success) {
            resolve(res)
          } else {
            reject(new Error('fail'))
          }
        }).catch(err => {
          reject(err)
        })
      })
    },
    republishArrangeDocument: function (token, mid) {
      return new Promise((resolve, reject) => {
        let data = this.$refs.viewer.getDocData()
        let name = [
          '申込書',
          this.$props.item.title
        ].join('_') + '.pdf'
        this.axios.post(this.$url.api + 'apply/doc/republish', {
          data: data,
          mid: mid,
          name: name,
          form: {
            id: this.$props.item.id,
            arranger: this.form.arranger,
            start: this.form.program.start,
            end: this.form.program.end
          }
        }, {
          headers: {
            'firebase-token': token
          },
          onUploadProgress: (e) => {
            this.$set(this.config.status, 'loading', Math.ceil((e.loaded / e.total + 1) / 2 * 100))
          }
        }).then(res => {
          console.log(res)
          if (res.data.success) {
            resolve(res)
          } else {
            reject(new Error('fail'))
          }
        }).catch(err => {
          reject(err)
        })
      })
    }
  },
  computed: {
    isValid () {
      return this.form.valid
    },
    isActive () {
      return !!this.config.status.active
    },
    isLoading () {
      return !!this.config.status.loading
    },
    isEditing () {
      return !!this.config.status.editing
    },
    isPublished () {
      return !!this.form.mid
    },
    getStatus () {
      return this.config.status
    },
    authedNavigation () {
      return ClientAboutRoutes.routes.filter(rt => {
        return this.config.about.pages.includes(rt.path)
      })
    },
    printAboutPage () {
      return this.config.about.pages[this.config.about.page] ? this.config.about.pages[this.config.about.page] : ''
    },
    printPublisherPage () {
      return this.config.publisher.pages[this.config.publisher.page] ? this.config.publisher.pages[this.config.publisher.page] : ''
    },
    printFormStart () {
      return this.form.program.start ? this.$moment(this.form.program.start).format('YYYY/MM/DD') : ''
    },
    printFormEnd () {
      return this.form.program.end ? this.$moment(this.form.program.end).format('YYYY/MM/DD') : ''
    },
    getBelongItems () {
      return Object.keys(this.$mango.belongs).map(key => {
        return {
          text: this.$mango.belongs[key],
          value: key
        }
      })
    },
    getArrangerItems () {
      let authors = this.$store.getters['config/get']('authors')
      return Object.keys(authors).filter(userid => {
        return authors[userid].roles.includes('consultant')
      }).map(userid => {
        return {
          userid,
          name: authors[userid].name[0]
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
